import React from 'react';
import { Route } from 'react-router-dom';
import CallScreen from './components/CallScreen';
import StatsScreen from './components/StatsScreen';

export default [
  <Route exact path="/stats/:ids" component={StatsScreen} />,
  <Route exact path="/call" component={CallScreen} />
];



// WEBPACK FOOTER //
// ./src/customRoutes.js